module.exports = __webpack_public_path__ + "static/quiz-0fa447fc98e76a4c401de2e0c1cbca7b.png";